  export default {
    created () {
      if (this.config && this.config.id && this.app && this.app.addComponent) {
        this.app.addComponent(this)
      }
    },

    destroyed () {
      if (this.config && this.config.id && this.app && this.app.removeComponent) {
        this.app.removeComponent(this)
      }
    }
  }
